// @flow
import { CLEAR_ALL_GROCERY_LIST_ITEMS } from "./actionTypes";

export default () => ({
  type: CLEAR_ALL_GROCERY_LIST_ITEMS,
  payload: {}
});